export default __webpack_public_path__ + "static/media/insta-icon.837a1fc5.svg";